import * as React from 'react';
import {Component} from "react";
import nophoto from "../../assets/img/nophoto.png"
import connect from "react-redux/es/connect/connect";
import HomePageAgentListLoaderCard from "../../../src/components/profile/home-page-agent-list-loader-card"
import {Link} from "react-router-dom";
import {Fragment} from "react";
import {actionGetAgents} from "../../actions/profile";
import CommanAgentCard from "./commanAgentCard";
import DataNotFound from "../layout/DataNotFound";
import {AGENTS} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import HeroSection from "../common/HerroSection/hero-section";

class AgentListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_lastData:true,
            q: '',
            offset: 0,
            limit: 15,
            errors: {},
        }
    }

    onChange = (e) => this.setState({[e.target.name]: e.target.value}, () => {
        if (this.state.q.length < 1) {
            this.setState({offset: 0});
            // this.props.actionGetAgents(this.state.q, `offset=${this.state.offset}`);
        }

    });

    handleSearchValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;
        if (!fields.q) {
            // formIsValid = false;
            // errors.q = "Please type something to search related data!";
        }

        this.setState({errors: errors});
        return formIsValid;
    };

    handleSearchSubmit = (e) => {
        console.log('handleSearchSubmit called');
        e.preventDefault();
        if (this.handleSearchValidation()) {
            this.setState({offset: 0});
            const request = {
                q :this.state.q,
                offset :this.state.offset,
                limit:this.state.limit
            };
            this.props.actionGetAgents(request);

        }

    };

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = "Agents | Prime Private Network";
        const request = {
            q :'',
            offset :0,
            limit:this.state.limit
        };
        this.props.actionGetAgents(request,this.setLastData);

        window.addEventListener('scroll', () => {
            let scrollHeight = document.documentElement.scrollHeight;
            let scrollTop = document.documentElement.scrollTop;
            let clientHeight = document.documentElement.clientHeight;

            if ((scrollTop + clientHeight) > (scrollHeight - 300) && this.props.agents.length && !this.props.agentsLoader && this.state.is_lastData) {
                this.setState({offset: this.state.offset + 1}, () =>  this.props.actionGetAgents({q:this.state.q,offset:this.state.offset,limit:this.state.limit},this.setLastData));
            }
        });
        this.setState({offset: 0});
    }

    setLastData=(status)=>{
        console.log(status,"status")
        this.setState({is_lastData:status})
    };
    render() {
        const {agentsLoader,agents} = this.props;
        console.log(this.props.agents,"agents")
        const loggedinId = this.props.user && this.props.user._id;
        //console.log(this.props.agents &&this.props.agents.sentRequests.map(friend => friend),'iddddddd');
        return (
            <Fragment>
                <Navbar scenario={AGENTS}/>
                <HeroSection title={'Agent'}/>
                <div className="container mt-5">
                    <div className="input-group mb-3 w-75 mx-auto">
                        <input type="text" className="form-control" placeholder="Search By  Agent Name or Agent Email"
                               aria-label="Recipient's username" aria-describedby="basic-addon2"
                               id="q" name={'q'}
                               value={this.state.q} onChange={this.onChange}/>
                            <div className="input-group-append">
                                <button className="btn btn-secondary" type="submit" onClick={this.handleSearchSubmit}>
                                    <i className="fa fa-search"/></button>
                            </div>
                    </div>
                        {
                            (this.props.agents && this.props.agents.length > 0) && this.props.agents.map((agents,i) =>
                                <CommanAgentCard
                                    role={agents.role.name}
                                    key={i}
                                    loggedinId={loggedinId}
                                    is_online={agents.is_online}
                                    is_typing={agents.is_typing}
                                    userId={agents._id}
                                    avatar={agents.avatar}
                                    name={agents.name}
                                    phone={agents.phone}
                                    email={agents.email}
                                    friends={agents.friends}
                                    country={agents.country.name ? agents.country.name : ''}
                                    state={agents.state.name ? agents.state.name : ''}
                                    city={agents.city.name ? agents.city.name : ''}
                                    properties={agents.properties}
                                    experience={agents.number_of_years_in_business}
                                    sentRequests={agents.sentRequests}
                                    receivedRequests={agents.receivedRequests}
                                    blockedFriends={agents.blockedFriends}
                                />)
                            }
                    {(!agentsLoader && agents.length < 1) &&
                    <div className="text-center col-md-12"><DataNotFound
                        message={`Sorry! No any Agent found.`}/></div>}


                        {(this.props.agentsLoader) && <Fragment>
                            <HomePageAgentListLoaderCard/>
                            <HomePageAgentListLoaderCard/>
                            <HomePageAgentListLoaderCard/>
                            <HomePageAgentListLoaderCard/>
                        </Fragment>}
                    </div>
            </Fragment>
        );
    }
}

const mapStatToProps = state => {
    return {
        agentsLoader: state.profile.agentsLoader,
        agents: state.profile.agents,
        user: state.auth.user
    }
};

export default connect(mapStatToProps, {actionGetAgents})(AgentListing);
